<h2 mat-dialog-title>Conferma upload del file XML</h2>

    <mat-dialog-content>
      <p>Per inviare la Fattura al server, devi accettare i termini del Servizio disponibili al seguente link:</p>
      <button 
        matButton
        (click)="legalConditionsRedirect()">
        <mat-icon>link</mat-icon>
        Termini e condizioni
      </button>
      <p class="mt-2">Autorizzo Izy Srl al trattamento dei dati che sto per inviare. Confermo che le informazioni inserite sono veritiere e accetto i Termini e Condizioni:</p>
      <mat-checkbox [(ngModel)]="confirmed">Confermo quanto riportato e accetto</mat-checkbox>
      <p class="mt-3">Note: la fattura non viene inviata allo SDI, ma resta a disposizione sul tuo profilo per il calcolo di tasse, contributi e fatturato totale.</p>
      <p>Se il cliente presente nella fattura non esiste nella tua anagrafica, verrà creato in automatico.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Indietro</button>
      <button mat-raised-button color="primary" [disabled]="!confirmed" (click)="confirm()">
        <mat-icon>check</mat-icon>
        Confermo
      </button>
    </mat-dialog-actions>
